module.exports = __webpack_public_path__ + "media/images/backgrounds/background-feature-drills-e75ee3bfaff73ba8c3a549b3df103d92.svg";